<div class="main-panel">
  <nz-spin [nzSpinning]="loadingTree" nzSize="large" class="tree-spin">
    <div class="action">
      <h3 class="tree-title">{{treename}}</h3>
      <span class="spacer"></span>
      <div class="vl"></div>
      <nz-icon nzType="reload" class="action-icon" nz-tooltip
        [nzTooltipTitle]="'amazon.criacao.refresh'|translateTA" (click)="doInit(true)" />
      <nz-icon nzType="plus" class="action-icon" nz-tooltip
        [nzTooltipTitle]="'amazon.criacao.expandAll'|translateTA" (click)="cts.executeAll(list,true,productData)" />
      <nz-icon nzType="minus" class="action-icon" nz-tooltip
        [nzTooltipTitle]="'amazon.criacao.collapseAll'|translateTA" (click)="cts.executeAll(list,false,null)" />
    </div>
    <div class="dropdown-divider"></div>
    <div class="tree">
      <custom-tree-view [items]="listSyncTemp | async" [parent]="productData" [detail]="template">

      </custom-tree-view>
    </div>
  </nz-spin>
</div>

<ng-template #template let-item="item" let-path="path">
  <div *ngIf="item.isopen && item.isvisible">
    <form [formGroup]="getFormGroup(path)">

      <!-- Enum -->
      <div class="tem-field tree-field" [ngStyle]="{'margin-left':getMargin(item)}"
        *ngIf="item.enum !=null && item.enum.length > 0 && item.child.length == 0">
        <span class="tem-field-label">{{item.columnName}}</span>
        <nz-select [formControlName]="item.columnName" nzShowSearch nzAllowClear [nzPlaceHolder]="item.columnName">
          <nz-option *ngFor="let tipo of item.enum" [nzValue]="tipo" [nzLabel]="tipo"></nz-option>
        </nz-select>
      </div>
      <button nz-button nzType="primary" nzShape="circle" nzSize="small" type="button" *ngIf="item.multi"
        nz-tooltip [nzTooltipTitle]="'amazon.criacao.addItem'|translateTA">
        <nz-icon nzType="plus" />
      </button>

      <!-- Booleano -->
      <div class="tem-field tree-field" [ngStyle]="{'margin-left':getMargin(item)}"
        *ngIf="item.child.length == 0 && item.type == 'boolean'">
        <span class="tem-field-label">{{item.columnName}}</span>
        <nz-select [formControlName]="item.columnName" nzAllowClear [nzPlaceHolder]="item.columnName">
          <nz-option *ngFor="let tipo of [true,false]" [nzValue]="tipo"
            [nzLabel]="(tipo ? 'amazon.criacao.true' : 'amazon.criacao.false')|translateTA"></nz-option>
        </nz-select>
      </div>

      <!-- Texto -->
      <div class="tem-field tree-field" [ngStyle]="{'margin-left':getMargin(item)}"
        *ngIf="(item.enum ==null || item.enum.length == 0) && ((item.type != null && (item.type=='string' || item.type=='normalizedString')) || item.type=='anyURI')">
        <span class="tem-field-label">{{item.columnName}}</span>
        <nz-input-group [nzSuffix]="strSuffix">
          <input nz-input [placeholder]="item.columnName" [formControlName]="item.columnName" />
        </nz-input-group>
        <ng-template #strSuffix>
          <nz-icon nzType="rollback" class="field-action" nz-tooltip
            [nzTooltipTitle]="'amazon.criacao.fetchData'|translateTA"
            (click)="dynamicServices.getDataFromTable(getFormGroup(path),item.columnName, 'MKTPAMAZON',geralGroup, path.replaceAll('>','.'),'text')" />
          <nz-icon nzType="close-circle" class="field-action" nz-tooltip
            [nzTooltipTitle]="'amazon.criacao.clear'|translateTA"
            (click)="clearField(path, item.columnName)" />
        </ng-template>
      </div>

      <!-- Data -->
      <div class="tem-field tree-field" [ngStyle]="{'margin-left':getMargin(item)}"
        *ngIf="(item.enum ==null || item.enum.length == 0) && item.child.length == 0 && (item.type == 'dateTime')">
        <span class="tem-field-label">{{item.columnName}}</span>
        <nz-date-picker [nzId]="item.columnName" [formControlName]="item.columnName" [nzPlaceHolder]="item.columnName"></nz-date-picker>
      </div>

      <!-- Inteiro -->
      <div class="tem-field tree-field" [ngStyle]="{'margin-left':getMargin(item)}"
        *ngIf="(item.enum ==null || item.enum.length == 0) && (item.type == 'positiveInteger' || item.type == 'integer')">
        <span class="tem-field-label">{{item.columnName}}</span>
        <nz-input-group [nzSuffix]="intSuffix">
          <input nz-input type="number" [placeholder]="item.columnName" [formControlName]="item.columnName" />
        </nz-input-group>
        <ng-template #intSuffix>
          <nz-icon nzType="rollback" class="field-action" nz-tooltip
            [nzTooltipTitle]="'amazon.criacao.fetchData'|translateTA"
            (click)="dynamicServices.getDataFromTable(getFormGroup(path),item.columnName, 'MKTPAMAZON', geralGroup, path.replaceAll('>','.'),'number')" />
          <nz-icon nzType="close-circle" class="field-action" nz-tooltip
            [nzTooltipTitle]="'amazon.criacao.clear'|translateTA"
            (click)="clearField(path, item.columnName)" />
        </ng-template>
      </div>

      <!-- Numero (decimal) -->
      <div class="tem-field tree-field" [ngStyle]="{'margin-left':getMargin(item)}"
        *ngIf="(item.enum ==null || item.enum.length == 0) && (item.type == 'number' || item.type == 'decimal')">
        <span class="tem-field-label">{{item.columnName}}</span>
        <nz-input-group [nzSuffix]="numSuffix">
          <input nz-input type="number" [placeholder]="item.columnName" [formControlName]="item.columnName" />
        </nz-input-group>
        <ng-template #numSuffix>
          <nz-icon nzType="rollback" class="field-action" nz-tooltip
            [nzTooltipTitle]="'amazon.criacao.fetchData'|translateTA"
            (click)="dynamicServices.getDataFromTable(getFormGroup(path),item.columnName, 'MKTPAMAZON', geralGroup, path.replaceAll('>','.'),'number')" />
          <nz-icon nzType="close-circle" class="field-action" nz-tooltip
            [nzTooltipTitle]="'amazon.criacao.clear'|translateTA"
            (click)="clearField(path, item.columnName)" />
        </ng-template>
      </div>
    </form>
  </div>

</ng-template>
